import Events from "../Components/Events";
import Footer from "../Components/Footer";
import React from 'react';

function EventsPage()  {
    return(
			<div>
            	<Events />
            	<Footer />
           </div>
	)}

export default EventsPage
